var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "grid-x grid-padding-x grid-padding-y pega-form",
      class: _vm.formClassName,
      attrs: { "data-test": "form-class" },
    },
    [
      _c(
        "div",
        {
          staticClass: "medium-3 cell pega-form-label",
          class: _vm.className,
          attrs: { "data-test": "form-label" },
        },
        [
          _vm._t("label"),
          _vm._v(" "),
          _vm.label ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
          _vm._v(" "),
          _vm.requiredLabel
            ? _c(
                "span",
                {
                  staticClass: "label alert pega-block-fit-content",
                  attrs: { "data-test": "alert-label" },
                },
                [_vm._v(_vm._s(_vm.requiredLabel))]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "auto cell" },
        [
          _vm._t("header"),
          _vm._v(" "),
          _vm._t("body"),
          _vm._v(" "),
          _vm._t("error"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }